import { __assign, __awaiter, __generator } from "tslib";
import { OfficeActionTelemetryId, } from '@office-start/action-types';
import { getFileTypeNameFromType } from '@office-start/file-utility';
import { logClickEvent, logDebugCacheEvent, logGenericEvent, logPerformanceEvent, logRequestEvent, } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logDiagnostic, logFeature, logPerformance, logReferUserAction, logRequest, logUserAction, } from '@office-start/telemetry-service';
export function getActionTelemetryConfig(entityType, entityData, sourceUXComponent, itemCategory, actionMenuSource) {
    var _a, _b;
    if (actionMenuSource === void 0) { actionMenuSource = 'ContentActionsMenuItem'; }
    var params = {};
    if (entityType == 'content') {
        params["DocumentId" /* InstrumentationParam.DocumentId */] = entityData.id;
        params["DocumentType" /* InstrumentationParam.DocumentType */] = getFileTypeNameFromType(entityData.fileType);
        params["ItemCategory" /* InstrumentationParam.ItemCategory */] = itemCategory;
        params["Pinned" /* InstrumentationParam.Pinned */] =
            ((_a = entityData.isPinned) === null || _a === void 0 ? void 0 : _a.toString()) || '';
        // ResourceId likely not needed: params[InstrumentationParam.ResourceId] = this.item.resourceId;
        params["ActivityCollaboration" /* InstrumentationParam.ActivityCollaboration */] =
            ((_b = entityData.isCollab) === null || _b === void 0 ? void 0 : _b.toString()) || '';
    }
    var telemetryConfig = {
        sourceUXComponent: sourceUXComponent,
        params: params,
        actionMenuSource: actionMenuSource,
    };
    return telemetryConfig;
}
export var logActionClickEvent = function (telemetryConfig) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (!telemetryConfig || !telemetryConfig.actionId) {
            return [2 /*return*/];
        }
        telemetryConfig.params["AppId" /* InstrumentationParam.AppId */] = telemetryConfig.appId;
        // Log aria action click
        logClickEvent(KnownInstrumentationEvents.ContentActionsMenuItemClick, OfficeActionTelemetryId[telemetryConfig.actionId] ||
            telemetryConfig.actionId, telemetryConfig.sourceUXComponent, telemetryConfig.referral, telemetryConfig.referralPlatform, telemetryConfig.params);
        // Log OTEL action click referral thats used separately for okr's
        if (telemetryConfig.referral) {
            logReferUserAction(OfficeActionTelemetryId[telemetryConfig.actionId] ||
                telemetryConfig.actionId, telemetryConfig.sourceUXComponent, telemetryConfig.referral, telemetryConfig.actionMenuSource, undefined, KnownInstrumentationEvents.ContentActionsMenuItemClick);
        }
        else {
            // Log OTEL action click
            logUserAction({
                id: OfficeActionTelemetryId[telemetryConfig.actionId] ||
                    telemetryConfig.actionId,
                area: telemetryConfig.sourceUXComponent,
                subArea: telemetryConfig.actionMenuSource,
                result: 'Navigate',
                target: 'ContentActions',
                eventName: KnownInstrumentationEvents.ContentActionsMenuItemClick,
            });
        }
        return [2 /*return*/];
    });
}); };
export var logActionGenericEvent = function (telemetryConfig, result) { return __awaiter(void 0, void 0, void 0, function () {
    var actionId, errorMessage, debugMessage;
    var _a;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
        if (!telemetryConfig || !telemetryConfig.actionId || !result) {
            return [2 /*return*/];
        }
        actionId = OfficeActionTelemetryId[telemetryConfig.actionId] ||
            telemetryConfig.actionId;
        telemetryConfig.params["ElementId" /* InstrumentationParam.ElementId */] = actionId;
        telemetryConfig.params["AppId" /* InstrumentationParam.AppId */] = telemetryConfig.appId;
        telemetryConfig.params["Area" /* InstrumentationParam.Area */] =
            telemetryConfig.sourceUXComponent;
        if (result === null || result === void 0 ? void 0 : result.additionalParams) {
            telemetryConfig.params = __assign(__assign({}, telemetryConfig.params), result.additionalParams);
        }
        if (result.success) {
            telemetryConfig.params["State" /* InstrumentationParam.State */] = 'Success';
        }
        else {
            errorMessage = result.error
                ? "".concat((_b = result.error) === null || _b === void 0 ? void 0 : _b.errorCode, " : ").concat((_c = result.error) === null || _c === void 0 ? void 0 : _c.errorMessage)
                : '';
            telemetryConfig.params["State" /* InstrumentationParam.State */] = 'Error';
            telemetryConfig.params["Error" /* InstrumentationParam.Error */] = errorMessage;
            debugMessage = "".concat(((_d = result === null || result === void 0 ? void 0 : result.error) === null || _d === void 0 ? void 0 : _d.additionalMessage)
                ? "".concat((_e = result === null || result === void 0 ? void 0 : result.error) === null || _e === void 0 ? void 0 : _e.additionalMessage, "; ")
                : '').concat((result === null || result === void 0 ? void 0 : result.additionalParams) &&
                (result === null || result === void 0 ? void 0 : result.additionalParams["DebugInfo" /* InstrumentationParam.DebugInfo */])
                ? result.additionalParams["DebugInfo" /* InstrumentationParam.DebugInfo */]
                : '');
            if (debugMessage && debugMessage !== '') {
                logActionDebugCacheEvent(actionId, debugMessage, telemetryConfig);
            }
        }
        // Log aria action success or error generic event
        logGenericEvent(result.success
            ? KnownInstrumentationEvents.ContentActionSuccess
            : KnownInstrumentationEvents.ContentActionError, telemetryConfig.params);
        //Log to OTEL
        logFeature({
            featureName: "ContentActions" /* KnownFeatureNames.ContentActions */,
            eventName: KnownInstrumentationEvents.ContentActionCompleted,
            params: __assign(__assign({}, result.additionalParams), (_a = { State: result.success ? 'Success' : 'Error', Message: errorMessage || '', Action: actionId }, _a["".concat("DocumentId" /* InstrumentationParam.DocumentId */)] = telemetryConfig.params["DocumentId" /* InstrumentationParam.DocumentId */] || '', _a["".concat("DocumentType" /* InstrumentationParam.DocumentType */)] = telemetryConfig.params["DocumentType" /* InstrumentationParam.DocumentType */] || '', _a)),
            area: 'ContentActions',
            subArea: telemetryConfig.actionMenuSource,
        });
        return [2 /*return*/];
    });
}); };
/**
 * Logs any http requests that do not go through the xhr-service
 * Today, these are mostly Graph requests that utilize the
 * @microsoft/microsoft-graph-client JavaScript library
 * @param logRequestEventOptions minimal set of options to log an xhr request
 */
export var logActionRequestEvent = function (logRequestEventOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var eventName, otelEventName, httpCode, latency, error;
    return __generator(this, function (_a) {
        eventName = logRequestEventOptions.eventName, otelEventName = logRequestEventOptions.otelEventName, httpCode = logRequestEventOptions.httpCode, latency = logRequestEventOptions.latency, error = logRequestEventOptions.error;
        //Log Aria Request Event
        logRequestEvent(eventName, httpCode, latency, error);
        //Log OTEL Request Event
        logRequest({
            eventName: otelEventName,
            httpCode: httpCode,
            latency: latency,
            error: error,
        });
        return [2 /*return*/];
    });
}); };
export var logActionPerfEvent = function (telemetryConfig, startTime, completeTime) {
    if (!telemetryConfig ||
        !telemetryConfig.actionId ||
        !startTime ||
        !completeTime) {
        return;
    }
    var eventName = "Content_Action_".concat(OfficeActionTelemetryId[telemetryConfig.actionId] ||
        telemetryConfig.actionId, "_complete");
    //Log Aria Perf Event
    logPerformanceEvent(eventName, completeTime - startTime);
    //Log OTEL perf event
    logPerformance({
        eventName: eventName,
        latency: completeTime - startTime,
        area: telemetryConfig.sourceUXComponent,
        subArea: telemetryConfig.actionMenuSource,
    });
};
export var logActionDebugCacheEvent = function (actionId, debugInfo, telemetryConfig) {
    var _a;
    if (!actionId || !debugInfo) {
        return;
    }
    var eventName = "Content_Action_Error_".concat(OfficeActionTelemetryId[actionId] || actionId);
    var params = (_a = {},
        _a["DebugInfo" /* InstrumentationParam.DebugInfo */] = debugInfo,
        _a);
    //Log Aria Debug Cache Event
    logDebugCacheEvent(eventName, params);
    // ToDo: Remove when Otel LogError handles this
    //Log OTEL Diagnostic event
    logDiagnostic({
        eventName: eventName,
        params: params,
        area: telemetryConfig === null || telemetryConfig === void 0 ? void 0 : telemetryConfig.sourceUXComponent,
        subArea: telemetryConfig === null || telemetryConfig === void 0 ? void 0 : telemetryConfig.actionMenuSource,
    });
};
export var logActionInitializationEvent = function (initializationEventName, isError, message) { return __awaiter(void 0, void 0, void 0, function () {
    var params;
    var _a;
    return __generator(this, function (_b) {
        params = (_a = {},
            _a["ElementId" /* InstrumentationParam.ElementId */] = initializationEventName,
            _a);
        if (isError) {
            params["Error" /* InstrumentationParam.Error */] = message !== null && message !== void 0 ? message : 'Unable to initialize';
        }
        else if (message) {
            params["DebugInfo" /* InstrumentationParam.DebugInfo */] = message;
        }
        //Log to Aria
        logGenericEvent(KnownInstrumentationEvents.ContentActionInitialization, params);
        //Log to OTEL
        logFeature({
            featureName: "ContentActions" /* KnownFeatureNames.ContentActions */,
            eventName: KnownInstrumentationEvents.ContentActionInitialization,
            params: {
                State: isError ? 'Error' : 'Success',
                Message: message !== null && message !== void 0 ? message : (isError ? 'Unable to initialize' : ''),
                Action: initializationEventName,
            },
            area: 'ContentActions',
        });
        return [2 /*return*/];
    });
}); };
export var addValueToDebugInfo = function (newValue, paramsObj) {
    var _a;
    return __assign(__assign({}, paramsObj), (_a = {}, _a["DebugInfo" /* InstrumentationParam.DebugInfo */] = "".concat((paramsObj === null || paramsObj === void 0 ? void 0 : paramsObj["DebugInfo" /* InstrumentationParam.DebugInfo */]) || '').concat(newValue, ";"), _a));
};
export var logRegisteredActions = function (systemUserConfig, actionsRegistered) {
    var _a;
    var actionsRegisteredDelimitedString = actionsRegistered.reduce(function (delimitedString, action) {
        return "".concat(delimitedString, " ").concat(OfficeActionTelemetryId[action.metadata.id] ||
            action.metadata.id, ";");
    }, '');
    var params = (_a = {},
        _a["IsCalendarEnabled" /* InstrumentationParam.IsCalendarEnabled */] = systemUserConfig.calendarEnabled.toString(),
        _a["IsExchangeEnabled" /* InstrumentationParam.IsExchangeEnabled */] = systemUserConfig.exchangeEnabled.toString(),
        _a["IsOneDriveEnabled" /* InstrumentationParam.IsOneDriveEnabled */] = systemUserConfig.oneDriveEnabled.toString(),
        _a["ActionsConfig" /* InstrumentationParam.ActionsConfig */] = actionsRegisteredDelimitedString,
        _a);
    //Log to OTEL
    logFeature({
        featureName: "ContentActions" /* KnownFeatureNames.ContentActions */,
        eventName: KnownInstrumentationEvents.ContentActionRegistered,
        params: params,
        area: 'ContentActions',
    });
    //Log to Aria
    logGenericEvent(KnownInstrumentationEvents.ContentActionRegistered, params);
};
//# sourceMappingURL=actionTelemetry.js.map